
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayStacked10 as ObiTwowayStacked10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-stacked-10.js';
 
 
 

 
 export const ObiTwowayStacked10 = createComponent({
   react: React,
   tagName: 'obi-twoway-stacked-10',
   elementClass: ObiTwowayStacked10Element,
   events: {
     
   }
  });
 
 